/**
 * Centralized toast configuration helpers.
 * Eliminates repetitive toast config objects across all components.
 *
 * Usage:
 *   import { showSuccess, showError } from "../../utils/toast";
 *   showSuccess("Document saved successfully");
 *   showError("Failed to save document");
 */
import { toast } from "react-toastify";

const BASE_CONFIG = {
  position: "top-center",
  autoClose: 3000,
  theme: "dark",
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};

const ERROR_CONFIG = {
  ...BASE_CONFIG,
  autoClose: 5000,
  position: "top-center",
};

export const showSuccess = (message, config = {}) =>
  toast.success(message, { ...BASE_CONFIG, ...config });

export const showError = (message, config = {}) =>
  toast.error(message, { ...ERROR_CONFIG, ...config });

export const showInfo = (message, config = {}) =>
  toast.info(message, { ...BASE_CONFIG, ...config });

export const showWarning = (message, config = {}) =>
  toast.warning(message, { ...BASE_CONFIG, ...config });
